var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_c("b", [_vm._v(_vm._s(_vm.declaration.title))])]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container-items" },
      _vm._l(_vm.declaration.items, function (indicador, index) {
        return _c("Indicador", {
          key: index,
          attrs: { declaration: indicador, color: _vm.getColor(index) },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }